import { render, staticRenderFns } from "./PrizesPayments.vue?vue&type=template&id=6ae687dc&scoped=true&"
import script from "./PrizesPayments.js?vue&type=script&lang=js&"
export * from "./PrizesPayments.js?vue&type=script&lang=js&"
import style0 from "./PrizesPayments.scss?vue&type=style&index=0&id=6ae687dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae687dc",
  null
  
)

export default component.exports